/**
 * SSOT for "which mobile bottom nav is shown". Agency staff outside God Mode get
 * the compact two-destination nav (Portfolio / Settings); everyone else (incl.
 * agency staff in God Mode, super admins) gets the full nav.
 */
interface BottomNavUser {
  isAgencyStaff?: boolean;
  godModeSession?: unknown;
}

export function usesAgencyStaffNav(user: BottomNavUser | null | undefined): boolean {
  return user?.isAgencyStaff === true && !user?.godModeSession;
}
